const KEY = 'typerv-browser-id';

const newId = () =>
  typeof crypto !== 'undefined' && 'randomUUID' in crypto
    ? crypto.randomUUID()
    : 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
        const r = (Math.random() * 16) | 0;
        return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
      });

/**
 * A random, anonymous ID for this browser. It's sent with practice runs and test tries so the
 * admin can see whether a candidate practised before their test. Null when storage is blocked;
 * practice and tests work the same either way.
 */
export const browserId = (): string | null => {
  try {
    let id = localStorage.getItem(KEY);
    if (!id) {
      id = newId();
      localStorage.setItem(KEY, id);
    }
    return id;
  } catch {
    return null;
  }
};
